"use client";

import { RootState } from "interfaces/generics.type";
import { getOrCreateStore } from "modules/lib/with-redux-store";

export function getBaseEvent(eventName: any, eventType: any) {
  // uiTaxonomyVersion,timestamp, eventName, eventType, url, referer and payload will be in every event
  const store: RootState = getOrCreateStore().getState();
  const { postalCode } = store.shoppingCart;
  return {
    timestamp: new Date().toISOString(),
    eventName,
    eventType,
    url: window.location.href,
    platform: window.navigator.platform,
    version: window.version,
    postalCode,
  };
}
